export default ({ placeholder }) => ({
  component: 'text-filter',
  componentAttrs: {
    placeholder,
  },
});
